import React from "react";

// plugin imports
import { motion } from "motion/react";

// style imports
import "./diagonalReveal.scss";

// component imports

// util imports

// svg imports

// component
export default function DiagonalReveal({
	children,
	show = true,
	angle = 110,
	duration = 0.5,
	delay = 0.25 * duration,
	index = 0,
	className = "",
	waitForLoad = true,
	...delegated
}) {
	const [loaded, setLoaded] = React.useState(!waitForLoad);

	const childrenWithOnLoad = React.useMemo(() => {
		if (!waitForLoad) return children;
		return React.Children.map(children, (child) => {
			if (React.isValidElement(child)) {
				return React.cloneElement(child, {
					onLoad: (e) => {
						setLoaded(true);
						if (child.props.onLoad) {
							child.props.onLoad(e);
						}
					},
				});
			}
			return child;
		});
	}, [children, waitForLoad]);

	return (
		<motion.div
			className={`diagonalRevealContainer ${className}`}
			variants={{
				hidden: {
					maskPosition: "0% 0%",
					WebkitMaskPosition: "0% 0%",
					transition: {
						duration: duration,
						delay: delay - delay * index,
					},
				},
				show: {
					maskPosition: show && loaded ? "100% 0%" : "0% 0%",
					WebkitMaskPosition: show && loaded ? "100% 0%" : "0% 0%",
					transition: {
						duration: duration,
						delay: show ? delay - delay * index : delay * index,
					},
				},
				exit: {
					maskPosition: "0% 0%",
					WebkitMaskPosition: "0% 0%",
					transition: {
						duration: duration,
						delay: delay * index,
					},
				},
			}}
			style={{
				maskImage: `linear-gradient(
					${angle}deg,
					transparent 50%,
					black 50.1%
					)`,
				WebkitMaskImage: `linear-gradient(
					${angle}deg,
					transparent 50%,
					black 50.1%
					)`,
			}}
			{...delegated}
		>
			{childrenWithOnLoad}
		</motion.div>
	);
}
